export default __webpack_public_path__ + "static/media/DSC08451.8fbf6dfe.jpg";